












import { TranslateResult } from "vue-i18n";
import { Component, Inject, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";

@Component
export default class Header extends Vue {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

    get portalTarget(): string {
        return PORTAL_TARGET;
    }
}
